module.exports = __webpack_public_path__ + "interactiveApp/KurzByk/media/4.svg";